"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var insert_button_html_1 = require("./insert_button_html");
var insert_success_html_1 = require("./insert_success_html");
var location_1 = require("./libraries/location");
require("isomorphic-fetch");
var root = require("window-or-global");
// one-stop command to prepare, load and enable the chat
function activate(store, deptid) {
    return __awaiter(this, void 0, void 0, function () {
        var available;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (deptid) {
                        store.commit('SET_DEPT_ID', deptid);
                    }
                    return [4 /*yield*/, store.dispatch('fetchAvailability')];
                case 1:
                    available = _a.sent();
                    if (available) {
                        store.commit('SET_ACTIVATED', available);
                    }
                    store.dispatch('loadButton');
                    return [2 /*return*/];
            }
        });
    });
}
// load data from the backend-API and fill the store with it
function fetchAvailability(store) {
    return __awaiter(this, void 0, void 0, function () {
        var url, data, available;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!store.getters['available']) return [3 /*break*/, 1];
                    return [2 /*return*/, true];
                case 1:
                    url = 'https://' +
                        location_1.Location.location() +
                        '/system/rest/v1.0/availability/' +
                        store.state.depId;
                    return [4 /*yield*/, getExternal(url)];
                case 2:
                    data = (_a.sent());
                    available = data.status.success && data.available && data.text > 0;
                    store.commit('SET_AVAILABILITY', available);
                    return [2 /*return*/, available];
            }
        });
    });
}
// adds the neccessary HTML/Script snippet before </body>, loading the button
function loadButton(store) {
    if (!store.getters['loaded']) {
        insert_button_html_1.insertButtonHtml(store.state.depId, location_1.Location.location());
        store.commit('SET_LOADED');
    }
}
function setDeptId(store, deptid) {
    if (deptid) {
        root.rpChatConfig = root.rpChatConfig || {};
        root.rpChatConfig.deptId = deptid;
        root.rpChatConfig.pagename = '';
        if (root.rp) {
            // console.log('setDeptId', root.rpChatConfig, deptid)
            root.rp.chat.changePage(root.rpChatConfig);
        }
        store.commit('SET_DEPT_ID', deptid);
    }
}
// simulates a click on the invisible button
function open(store) {
    if (!root.document) {
        return;
    }
    if (store.getters['loaded'] && root.rp) {
        // this DOM element gets inserted dynamically after loadButton()
        /* const statusTextButton = root.document.getElementById(
          'realperson_text_status_button'
        )
        if (statusTextButton) {
          statusTextButton.click()
        } */
        root.rp.chat.Core.startChat(1);
    }
}
// trigger external tracking, but only if cookie exists
function track(store, args) {
    if (!root.document) {
        return;
    }
    var cookieExists = /ONLINEBERATUNG/i.test(root.document.cookie);
    var alreadyTracked = store.getters['tracked'];
    if (cookieExists && !alreadyTracked) {
        var location_2 = location_1.Location.location();
        var url = createUrl('https://' + location_2 + '/system/report.php', args);
        insert_success_html_1.insertSuccessHtml(url);
    }
}
// export everything compliant to the vuex specification for actions
exports.default = {
    activate: activate,
    fetchAvailability: fetchAvailability,
    loadButton: loadButton,
    open: open,
    setDeptId: setDeptId,
    track: track,
};
/**
 * just build an fully qualified URL with GET-Parameters
 */
function createUrl(url, params) {
    var query = params !== undefined ? objToQuery(params) : '';
    return url + query;
}
/**
 * HTTP-GET json data from an absolute url with optional GET-parameters
 */
function getExternal(path, params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = createUrl(path, params);
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, result.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * objToQuery transforms a given object into a HTTP-GET parameters string
 */
function objToQuery(json) {
    var str = Object.keys(json)
        .map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(json[k]);
    })
        .join('&');
    if (str === '') {
        return '';
    }
    else {
        return "?" + str;
    }
}
//# sourceMappingURL=actions.js.map